import client from './client'

export interface Device {
  id: string
  name: string
  description?: string
  status: 'online' | 'offline'
  last_seen?: string
  profile_id?: string
  owner_id?: string
  created_at: string
}

export interface DeviceListResponse {
  items: Device[]
  total: number
  page: number
  page_size: number
}

export interface DeviceCreate {
  name: string
  description?: string
  profile_id: string
}

export interface DeviceRegisterResponse extends Device {
  api_key: string
}

export const devicesApi = {
  list: (params?: { status?: string; page?: number; page_size?: number }) =>
    client.get<DeviceListResponse>('/devices', { params }).then((r) => r.data),

  get: (id: string) =>
    client.get<Device>(`/devices/${id}`).then((r) => r.data),

  register: (data: DeviceCreate) =>
    client.post<DeviceRegisterResponse>('/devices', data).then((r) => r.data),

  update: (id: string, data: Partial<DeviceCreate>) =>
    client.patch<Device>(`/devices/${id}`, data).then((r) => r.data),

  delete: (id: string) =>
    client.delete(`/devices/${id}`),

  heartbeat: (deviceId: string, apiKey?: string) => {
    const headers: Record<string, string> = {}
    if (apiKey) headers['X-Device-Key'] = apiKey
    return client.get(`/heartbeat/${deviceId}`, { headers })
  },

  batchCreate: (data: { name_prefix: string; count: number; profile_id?: string }) =>
    client.post<{
      devices: Array<{ name: string; device_id: string; api_key: string; owner_id: string }>
    }>('/devices/batch', data).then((r) => r.data),

  exportDevices: (provisioned?: boolean, rotate?: boolean) =>
    client.get<Array<{ name: string; device_id: string; api_key: string; owner_id: string }>>(
      '/devices/export',
      { params: { provisioned, rotate } }
    ).then((r) => r.data),
}
